import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Modal,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "../../components/Modal";
import { useState } from "react";
import { API_ENDPOINTS, aspetto_logo } from "../../constant/_constant";
import mail_successfully from "../../assets/mail_successfully.svg";


function SuccessPopUp({ isOpen, setIsOpen,dataForSuccessPage,HeadingContent }) {
  
  const navigate = useNavigate();

  const handleClose = (path) => {
    setIsOpen(false); 
    navigate(path);  
  };

  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <ModalContent>
        <div className="text-center w-50 mb-3 m-auto">
          <img src={aspetto_logo} height={36} alt="aspetto_logo" />
        </div>
        <h2 className="h3 text-center mb-3">{HeadingContent}</h2>
        
     {dataForSuccessPage &&   <p className="text-center  text-success" >{dataForSuccessPage?.message}</p>}
        <button className="btn w-100 btn-warning mb-6" onClick={() => handleClose("/")}>
          Login Page
        </button>
        <div className="aspetto-modal-footer"><img src={mail_successfully} alt="successfull" /></div>
      </ModalContent>
    </Modal>
  );
}

export default SuccessPopUp;
